import { TableFooterType } from '../Table'
import './TableFooter.scss'

export const TableFooter: React.FC<TableFooterType> = ({
  children,
  colSpan,
}) => {
  if (children) {
    return (
      <tfoot className="TableFooter">
        <tr>
          <td colSpan={colSpan}>{children}</td>
        </tr>
      </tfoot>
    )
  }

  return null
}
